module.exports = __webpack_public_path__ + "static/img/service_cont_06_zh.fa73b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_cont_06_zh.png
// module id = HeGC
// module chunks = 34